// Core
// 
import { Controller } from 'stimulus';

// Helpers
// 
import { addClass, removeClass, hasClass } from '../../../dom-helper';

// Plugins
// 
import axios, { AxiosResponse } from 'axios';
import * as _ from 'lodash';

import * as baguetteBox from 'baguettebox.js';

export default class extends Controller {
  static targets = ['client', 'uri', 'reference', 'categories', 'types', 'items', 'preloadedCategories', 'hasCatalogueId', 'attributesSection', 'catalogueSelect'];

  clientTarget: any;
  uriTarget: any;

  referenceTarget: any;
  categoriesTarget: any;
  typesTarget: any;
  itemsTarget: any;
  itemID: any;
  preloadedCategoriesTarget: any;
  hasCatalogueIdTarget: any;
  attributesSectionTarget: any;
  catalogueSelectTarget: any;
  lastCatalogueItemId: string | null = null;

  uri: string;
  clientID: string;
  preloadedCategories: any[] = [];

  connect() {

    _.templateSettings = {
      interpolate: /\{\{\=(.+?)\}\}/g,
      evaluate: /\{\{(.+?)\}\}/g
    }

    this.uri = this.uriTarget.value;
    const params = new URLSearchParams(window.location.search);
    this.itemID = params.get("item_id");

    if (this.itemID) {
      this.setItem(null, this.itemID)
    }

    this.clientID = this.clientTarget.value;

    // Check if we have a catalogue_id parameter
    const hasCatalogueId = this.hasCatalogueIdTarget && this.hasCatalogueIdTarget.value === 'true';

    // Check if we have preloaded categories (when catalogue_id is present)
    if (this.preloadedCategoriesTarget && this.preloadedCategoriesTarget.value) {
      try {
        this.preloadedCategories = JSON.parse(this.preloadedCategoriesTarget.value);
        if (this.preloadedCategories && this.preloadedCategories.length > 0) {
          // Pre-populate categories from server data
          this.updateSelection(this.categoriesTarget, this.preloadedCategories, false);
          
          // if (this.referenceTarget && this.referenceTarget.value !== '') {
          //   this.setItem(null, this.referenceTarget.value);
          // }
          
          return; // Don't fetch from API, use preloaded data
        }
      } catch (e) {
        console.error('Failed to parse preloaded categories:', e);
      }
    }
    if (hasCatalogueId) {
      this.getCategories();
    }
    if (!hasCatalogueId && this.referenceTarget && this.referenceTarget.value !== '') {
      this.setItem(null, this.referenceTarget.value);
    }
    
  }

  // initialize() {
  //   document.addEventListener('turbolinks:load', (event) => {
  //     if (this.referenceTarget && this.referenceTarget.value != '') {
  //       this.setItem(null, this.referenceTarget.value)
  //     }
  //   })
  // }

  getCategories() {
    let single: boolean = false;

    axios.get(`${ this.uri }/categories`, { headers: { 'token' : this.getUserToken() } }).then((response: AxiosResponse<any>) => {
      const categories: any[] = response.data;

      single = (categories.length === 1);

      if (single) {
        this.updateSelection(this.categoriesTarget, categories, single);
        this.getTypes(null, categories[0].id);
      } else {
        this.updateSelection(this.categoriesTarget, response.data, single);
      }
    })
  }

  getTypes(event: any, categoryID: number) {
    const $id: string = event ? event.target.value : categoryID;
    let single: boolean = false;

    // Check if we have preloaded categories with types
    if (this.preloadedCategories && this.preloadedCategories.length > 0) {
      const category = this.preloadedCategories.find((c: any) => String(c.id) === String($id));
      if (category && category.types && category.types.length > 0) {
        const types = category.types;
        single = (types.length === 1);

        if (single) {
          this.updateSelection(this.typesTarget, types, single);
          this.getItems(null, types[0].id);
        } else {
          this.updateSelection(this.typesTarget, types, single);
        }
        return; // Use preloaded types, don't fetch from API
      }
    }

    // Fallback to API call if no preloaded data
    axios.get(`${ this.uri }/categories/${ $id }/types`).then((response: AxiosResponse<any>) => {
      const types: any[] = response.data;

      single = (types.length === 1);

      if (single) {
        this.updateSelection(this.typesTarget, types, single);
        this.getItems(null, types[0].id);
      } else {
        this.updateSelection(this.typesTarget, response.data, single);
      }
    })
  }

  getItems(event: any, typeID: number) {
    const $id: string = event ? event.target.value : typeID;

    axios.get(`${ this.uri }/types/${ $id }/items`).then((response: AxiosResponse<any>) => {
      const items: any[] = response.data;

      let container = document.getElementById('catalogueItemsTemplate'),
          template = _.template(container.innerHTML);

      document.getElementById('catalogueItems').innerHTML = template({
        items: items
      })
      this.initializeGallery();
    })
  }

  // As template renders plain text, we need to dynamically add baguetteBox to rendered content.
  initializeGallery() {
    baguetteBox.run(".lightbox");
  }

  catalogueSelected(event: any) {
    const catalogueId = event.target.value;
    
    if (!catalogueId) {
      // Clear categories and types if no catalogue selected
      if (this.categoriesTarget) {
        this.categoriesTarget.options.length = 0;
        this.categoriesTarget.appendChild(this.createOption('', 'Select a Category', null, true));
      }
      if (this.typesTarget) {
        this.typesTarget.options.length = 0;
        this.typesTarget.appendChild(this.createOption('', 'Select a Type', null, true));
      }
      return;
    }

    // Fetch categories for selected catalogue (catalogue_id query param — nested route may be unavailable)
    axios.get(`${this.uri}/categories`, {
      params: { catalogue_id: catalogueId },
      headers: { 'token': this.getUserToken() }
    }).then((response: AxiosResponse<any>) => {
      const categories: any[] = response.data;
      const single = (categories.length === 1);

      if (single) {
        this.updateSelection(this.categoriesTarget, categories, single);
        this.getTypes(null, categories[0].id);
      } else {
        this.updateSelection(this.categoriesTarget, categories, single);
      }
      
      // Clear types dropdown
      if (this.typesTarget) {
        this.typesTarget.options.length = 0;
        this.typesTarget.appendChild(this.createOption('', 'Select a Type', null, true));
      }
    }).catch((error) => {
      console.error('Failed to fetch categories for catalogue:', error);
      // Fallback to regular getCategories if endpoint doesn't exist
      this.getCategories();
    });
  }


  setItem(event: any, itemID?: string) {
    // Determine the item id (from param or from the clicked element)
    let $id: string | null = null;
    if (event) {
      // Prevent anchor navigation before any early return
      if (event.preventDefault) event.preventDefault();
      const srcEl: any = event.currentTarget || event.target;
      $id = (srcEl && srcEl.dataset && srcEl.dataset.id) ? srcEl.dataset.id : (srcEl && srcEl.value ? srcEl.value : null);
    }
    if (!$id && itemID) {
      $id = itemID;
    }

    console.log("ITEM ID:", $id);

    if (!$id) return;

    // Avoid re-selecting the same item
    if (this.lastCatalogueItemId === $id) return;
    this.lastCatalogueItemId = $id;

    axios.get(`${ this.uri }/items/${ $id }`).then((response: AxiosResponse<any>) => {
      const item: any = response.data;
      // Visible reference field (UX)
      if (this.referenceTarget) {
        this.referenceTarget.value = item.uuid;
      }

      // Single source of truth: hidden `item[catalogue_item_id]` field in the wizard
      const hiddenCatalogueIdField = document.querySelector('input[name="item[catalogue_item_id]"]') as HTMLInputElement;
      if (hiddenCatalogueIdField) {
        hiddenCatalogueIdField.value = item.uuid;
        // Trigger change so wizard controller updates review + internal state
        const changeEvent = new Event('change', { bubbles: true });
        hiddenCatalogueIdField.dispatchEvent(changeEvent);
      }
      // Render item details
      const itemContainer = document.getElementById('catalogueItem');
      const itemTemplateContainer = document.getElementById('catalogueItemTemplate');
      console.log("ITEM CONTAINER0000000000000:", item);
      const hiddenField = document.getElementById("category-color-field") as HTMLInputElement;
      if (hiddenField) {
        hiddenField.value = item.category.colour;
      }
      console.log("ITEM0000000000000:", item.category.colour);
      console.log("ITEM CATEGORY0000000000000:", hiddenField);
      console.log("HIDDEN FIELD0000000000000:", hiddenField.value);
      if (itemContainer && itemTemplateContainer) {
        const itemTemplate = _.template(itemTemplateContainer.innerHTML);
        itemContainer.innerHTML = itemTemplate({ item: item });
      }

      // Render attributes in separate section
      this.renderAttributes(item);
    })
  }

  private renderAttributes(item: any) {
    
    if (!item.attribute_associations || item.attribute_associations.length === 0) {
      // Hide attributes section if no attributes
      if (this.attributesSectionTarget) {
        this.attributesSectionTarget.style.display = 'none';
      }
      return;
    }

    // Show attributes section
    if (this.attributesSectionTarget) {
      this.attributesSectionTarget.style.display = 'block';
    }

    // Get attributes template
    const attributesTemplateContainer = document.getElementById('catalogueItemAttributesTemplate');
    const attributesContainer = document.getElementById('catalogueItemAttributes');
    
    if (!attributesTemplateContainer || !attributesContainer) {
      console.error('Attributes template or container not found');
      return;
    }

    const template = _.template(attributesTemplateContainer.innerHTML);
    const marketplaceDisabled = this.attributesSectionTarget?.getAttribute('data-marketplace-disabled') === 'true';
    attributesContainer.innerHTML = template({ item: item, marketplaceDisabled: marketplaceDisabled });
    
    // Dispatch event to notify wizard controller about attributes
    const event = new CustomEvent('catalogue:attributes-rendered', {
      detail: {
        attributeAssociations: item.attribute_associations
      },
      bubbles: true
    });
    document.dispatchEvent(event);
  }

  private updateSelection(selector, values, singleValue?) {
    selector.options.length = 0;

    addClass(selector, 'loading');

    if (values.length == 0) {
      selector.appendChild(this.createOption('', 'No data received'));
    } else {
      if (!singleValue) {
        selector.appendChild(this.createOption(null, 'Please select a Value', null, true));
      }

      values.forEach((value: any) => {
        selector.appendChild(this.createOption(value.id, value.name, singleValue));
      })

      removeClass(selector, 'loading');
      addClass(selector, 'loaded');
    }

    setTimeout(() => {
      removeClass(selector, 'loaded')
    }, 1000);
  }

  private createOption(value, label, selected?: any, disabled = false) {
    let option = document.createElement('option');

    option.value    = value;
    option.selected = selected || disabled;
    
    if (disabled) {
      option.disabled = disabled
    }

    option.appendChild(document.createTextNode(label));

    return option
  }

  getUserToken() {
    const metas = document.getElementsByTagName('meta');

    for (let i = 0; i < metas.length; i++) {
      const meta = metas[i];

      if (meta.getAttribute('name') === 'user-token') {
        return meta.getAttribute('content')
      }
    }

    return null
  }
}
